const API_BASE_URL = "https://api.ketobalanced.com/kpv20231";
//const API_BASE_URL = "https://api.ketobalanced.com";
export const KETO_IMG_CDN_LIVE = "https://kbcdn22.ketobalanced.com/extra-img";

export default API_BASE_URL;
